import type { Action } from "redux";

import type { ReferralActionTypes } from "@js/apps/dashboard/actions";

type AllowedActionTypes =
  ReferralActionTypes | (string & Record<string, never>);

// TODO add specific tracking types for all handlers
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TrackableUserAction<TPayload = any> = Action<AllowedActionTypes> & {
  payload: TPayload;
};

export const isTrackableUserAction = (
  action: unknown,
): action is TrackableUserAction => {
  if (typeof action !== "object" || action === null) {
    return false;
  }

  const { type } = action as TrackableUserAction;

  // Add any additional checks based on your requirements
  return typeof type === "string";
};
